import { create } from 'zustand';

export interface ActiveCalendarReminder {
  calendarEventId: string;
  title: string;
  startDate: string; // ISO
  location?: string;
  minutesBefore?: number;
}

interface CalendarReminderState {
  // The currently-alerting reminder, if any — drives
  // CalendarReminderAlertRoot's full-screen takeover. Only one at a time:
  // a second reminder firing while one is already showing simply replaces
  // it (matches how a phone's own alarm app behaves — no stacking).
  activeReminder: ActiveCalendarReminder | null;
  showReminder: (reminder: ActiveCalendarReminder) => void;
  dismissReminder: () => void;

  // CalendarReminderAlertRoot is mounted at the App.tsx root — a sibling of
  // AppNavigator, not inside it — so it has no direct access to
  // AppNavigator's own navigateTo (that lives on a per-render AppContext
  // instance created inside AppNavigator's switch, unreachable from outside
  // its tree). "View Event" instead writes the intended navigation here;
  // AppNavigator watches this field and calls its OWN navigateTo, then
  // clears it. Cross-tree navigation bridge, not real routing state.
  pendingNavigation: { screen: string; param?: string } | null;
  requestNavigation: (screen: string, param?: string) => void;
  clearPendingNavigation: () => void;
}

export const useCalendarReminderStore = create<CalendarReminderState>((set) => ({
  activeReminder: null,
  showReminder: (reminder) => set({ activeReminder: reminder }),
  dismissReminder: () => set({ activeReminder: null }),

  pendingNavigation: null,
  requestNavigation: (screen, param) => set({ pendingNavigation: { screen, param } }),
  clearPendingNavigation: () => set({ pendingNavigation: null }),
}));
